import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M13.1667 4.66634H14.8333C15.7538 4.66634 16.5 5.41253 16.5 6.33301V11.333C16.5 12.2535 15.7538 12.9997 14.8333 12.9997H13.1667V16.333L9.83333 12.9997H6.5C6.03976 12.9997 5.6231 12.8131 5.32149 12.5115M5.32149 12.5115L8.16667 9.66634H11.5C12.4205 9.66634 13.1667 8.92015 13.1667 7.99967V2.99967C13.1667 2.0792 12.4205 1.33301 11.5 1.33301H3.16667C2.24619 1.33301 1.5 2.0792 1.5 2.99967V7.99967C1.5 8.92015 2.24619 9.66634 3.16667 9.66634H4.83333V12.9997L5.32149 12.5115Z" />
  </svg>
);
